module.exports = __webpack_public_path__ + "f9743a545a44d3acc6e051e8618b6795.png";


//////////////////
// WEBPACK FOOTER
// ./assets/LogoTop2.png
// module id = 836
// module chunks = 66